import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initI18n } from '@hsc/i18n';
import { App } from './App.js';
import { applyTenantBranding } from './lib/tenant-branding.js';
import {
  applyTelegramSafeArea,
  isTelegramMiniApp,
  tryTelegramAutoLogin,
} from './lib/telegram-miniapp.js';
import './styles/global.css';

/** Короткий лоадер «Входим…» на время Telegram авто-логина. */
function renderTmaLoader(el: HTMLElement): void {
  el.innerHTML =
    '<main class="hsc-login"><div class="hsc-login__box">' +
    '<div class="hsc-login__brand"><span aria-hidden="true" class="hsc-login__logo">L</span>' +
    '<h1 class="hsc-login__title">Входим…</h1>' +
    '<p class="hsc-login__subtitle">Минуту, проверяем доступ</p></div></div></main>';
}

/**
 * Точка входа tenant-app. Инициализируем i18n (ru) и монтируем приложение.
 *
 * Telegram Mini App: если открыто из бота отеля (есть initData), сначала
 * пробуем авто-логин гостя (POST /v1/guest-auth/tg-webapp), показывая лоадер.
 * При успехе токены уже в хранилище → App стартует авторизованным гостем; при
 * not_bound уводим на self-auth (/guest-login). Вне Telegram — обычный поток.
 */
async function bootstrap(): Promise<void> {
  await initI18n({ fallbackLng: 'ru', lng: 'ru', loadPath: '/locales' });
  // Per-tenant брендинг вкладки (#43): favicon = логотип отеля, title =
  // название. Не блокируем рендер — обновит вкладку, как только ответит API.
  void applyTenantBranding();
  const el = document.getElementById('root');
  if (!el) throw new Error('tenant-app: #root not found in DOM');

  if (isTelegramMiniApp()) {
    // Поднять нижнюю нав-панель над системной зоной Telegram (#78).
    applyTelegramSafeArea();
    renderTmaLoader(el);
    const outcome = await tryTelegramAutoLogin();
    if (outcome === 'not_bound' && window.location.pathname === '/') {
      window.history.replaceState(null, '', '/guest-login');
    }
  }

  createRoot(el).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
